import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filesize',
})
export class FilesizePipe implements PipeTransform {
  private units: Array<string> = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

  transform(value: number): string {
    const byteUnitFactor = 1024;
    let unitIndex = 0;
    let bytes = value;
    if (bytes === 0) {
      return bytes.toString() + ' ' + this.units[unitIndex];
    }
    if (bytes === -1) {
      return '...';
    }

    while (bytes >= byteUnitFactor) {
      bytes /= byteUnitFactor;
      unitIndex++;
    }

    let bytesStr;
    if (bytes >= 1000 && bytes < byteUnitFactor) {
      bytesStr = bytes.toFixed(2).toString();
    } else {
      bytesStr = bytes.toPrecision(3).toString();
    }

    return bytesStr + ' ' + this.units[unitIndex];
  }
}
